// extracted by mini-css-extract-plugin
export default {"path":"Share_path__skOge","heading":"Share_heading__bAjv3","label":"Share_label__DwDbb","copy_container":"Share_copy_container__M+lnz"};